// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReactivateDtaRequestBody
 */
export interface ReactivateDtaRequestBody {
    /**
     * 
     * @type {string}
     * @memberof ReactivateDtaRequestBody
     */
    version?: string;
}

/**
 * Check if a given object implements the ReactivateDtaRequestBody interface.
 */
export function instanceOfReactivateDtaRequestBody(value: object): value is ReactivateDtaRequestBody {
    return true;
}

export function ReactivateDtaRequestBodyFromJSON(json: any): ReactivateDtaRequestBody {
    return ReactivateDtaRequestBodyFromJSONTyped(json, false);
}

export function ReactivateDtaRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReactivateDtaRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'version': json['version'] == null ? undefined : json['version'],
    };
}

export function ReactivateDtaRequestBodyToJSON(json: any): ReactivateDtaRequestBody {
    return ReactivateDtaRequestBodyToJSONTyped(json, false);
}

export function ReactivateDtaRequestBodyToJSONTyped(value?: ReactivateDtaRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'version': value['version'],
    };
}
